module.exports = __webpack_public_path__ + "1e62580beb5bdd115590e84c6fc3cd6e.svg";